/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Paused_Spaces_TitleInputs */



/**
* | output |
* | --- |
* | "Linked space paused" |
*
* @param {Project_Paused_Spaces_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_paused_spaces_title = /** @type {((inputs?: Project_Paused_Spaces_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Paused_Spaces_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verknüpfter Space pausiert")
	return /** @type {LocalizedString} */ ("Linked space paused")
});